$(function () {

    const navCategoryToggle = $('#navCategoryToggle');
    const nav_category_dropdown_menu = $('#nav_category_dropdown_menu');

    navCategoryToggle.on("click", () => {

        if (!nav_category_dropdown_menu.hasClass('opened')) {
            nav_category_dropdown_menu.addClass("opened");
            $("body").addClass("no-scroll");
        } else {
            nav_category_dropdown_menu.removeClass("opened");
            $("body").removeClass("no-scroll");
        }
    })


    $(".category_subnav__link:not('.category_subnav__link--inside')").on("mouseenter", function (event) {
        let $this = $(this);

        $(".category_subnav__inside").removeClass("show");

        if ($this.hasClass('has-category_subnav')) {
            let current_category_subnav = $this.nextAll(".category_subnav__inside");
            current_category_subnav.addClass("show");
        }
    });

    $(".nav__category_subnav-toggle").on("click", function (event) {
        let $this = $(this);
        let current_category_subnav = $this.nextAll(".category_mobile-toggle");
        $this.toggleClass("active");
        current_category_subnav.toggleClass("show");
    });

});